/*! Thom Advanced Search - v1 - 2020-07-30
* Copyright (c) 2020 THOM */

/* global window, document, define, jQuery, setInterval, clearInterval */
(function (factory) {
  'use strict'
  if (typeof define === 'function' && define.amd) {
    define(['jquery'], factory)
  } else if (typeof exports !== 'undefined') {
    module.exports = factory(require('jquery'))
  } else {
    factory(jQuery)
  }
}(function ($) {
  'use strict'

  // require('twbs-pagination')

  // THOM Menu
  var Thomsearch = window.Thomsearch || {}

  Thomsearch = (function () {
    function Thomsearch (element, settings) {
      var _ = this

      _.defaults = {
        filterClass: '',
        filtersContent: '',
        // inputText: null,
        infScroll: null,
        itemsPerPage: 10,
        onFilterClick: null,
        // onTextSearchEdit: null,
        // paginationClass: null,
        // paginationChild: '',
        resultsCallback: function () { },
        resultsNumber: '',
        submit: null,
        // submitText: null,
        url: '',
        urlContent: '',
        // urlContentByText: ''
      }

      $.extend(_, _.initials)

      _.$el = $(element);
      // _.imwriting = false;
      _.infScroll = null;
      // _.isTextSearch = false;
      _.resizing = false;
      // _.pageNumber = 0;
      // _.paginationTotalPages = 0;
      // _.$pagination = '';
      // _.$pagination_defaultOpts = null;
      // _.totalItems = 0;

      _.options = $.extend({}, _.defaults, settings);

      // A simple way to check for HTML strings
      // Strict HTML recognition (must start with <)
      // Extracted from jQuery v1.11 source
      _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;

      _.init(true);
    }

    return Thomsearch;
  }())

  Thomsearch.prototype.init = function (creation) {
    var _ = this;

    if (creation) {
      _.$el.trigger('init', [_]);
      // Set Listeners
      _.setlisteners();
    }
  }

  Thomsearch.prototype.setlisteners = function () {
    var _ = this;
    // Init
    // _.loadingShow();
    // _.getFiltered();

    // Filter click
    $(_.options.filterClass).click(function (e) {
      e.preventDefault();

      if (_.options.onFilterClick != null) {
        _.options.onFilterClick();
      }

      _.loadingShow();

      var _thisId = $(this).data('val');
      var selected_val;

      // if(_.options.infScroll){
      //   console.log('destroy infinite scroll')
      //   _.options.infScroll.infiniteScroll('destroy')
      // }

      

      
      if(THOM_searchFilters){
        $(this).toggleClass('is-selected');

        if ($(this).hasClass('is-selected')) {
          selected_val = true;
        } else {
          selected_val = false;
        }

        $(_.options.filterClass).addClass('is-refreshing');

        THOM_searchFilters = _.getObjects(THOM_searchFilters, 'Id', _thisId, 'Selected', selected_val);
        _.getFiltered();
      } else {
        $(_.options.filterClass).removeClass('is-selected');
        $(this).addClass('is-selected');
        _.getFilteredContents(_thisId);
      }
    });
  }

  Thomsearch.prototype.reset = function () {
    var _ = this
    $(_.options.filterClass).removeClass('is-refreshing is-selected is-inactive');
    $(_.options.filterClass).each(function () {
      var _thisId = $(this).data('val');
      THOM_searchFilters = _.getObjects(THOM_searchFilters, 'Id', _thisId, 'Selected', false);
      THOM_searchFilters = _.getObjects(THOM_searchFilters, 'Id', _thisId, 'Active', true);
    });
    _.getFiltered();
  }

  /* Loading - show */
  Thomsearch.prototype.loadingShow = function () {
    var _ = this;

    $('.thom-search--results').addClass('loading');

    var elem = document.createElement('div');
    elem.setAttribute('id', 'spinnersearch');
    elem.innerHTML =
      '<div class="sk-chase">' +
        '<div class="sk-chase-dot"></div>' +
        '<div class="sk-chase-dot"></div>' +
        '<div class="sk-chase-dot"></div>' +
        '<div class="sk-chase-dot"></div>' +
        '<div class="sk-chase-dot"></div>' +
        '<div class="sk-chase-dot"></div>' +
      '</div>';

      $('.thom-search .thom-dropdown').append(elem);
      $('#spinnersearch').fadeIn();
  }

  /* Loading - hide */
  Thomsearch.prototype.loadingHide = function () {
    var _ = this;
    $('#spinnersearch').fadeOut(300, function(){
      $(this).remove();
      $('.thom-search--results').removeClass('loading');
    });
  }

  /* Get Contents JSON Object */
  Thomsearch.prototype.getFilteredContents = function (value) {
    var _ = this;

    var postdata;

    if(!value){
      postdata = { selectedFilters: THOM_searchFilters, itemsXPage: _.options.itemsPerPage }
      postdata = JSON.stringify(postdata);
      
      $.ajax({
        type: 'POST',
        url: _.options.urlContent,
        contentType: 'application/json; charset=utf-8',
        data: postdata,
        dataType: 'html',
        success: function (data) {  
          _.options.resultsCallback(data/* , _.paginationTotalPages, _.totalItems */)
        }
      })

    } else {
      postdata = { filter: value };
      $.ajax({
        url: _.options.urlContent,
        data: postdata,
        dataType: 'html',
        success: function (data) {
          _.options.resultsCallback(data)
        }
      })
    }  
  }

  /* Send JSON Object */
  Thomsearch.prototype.getFiltered = function () {
    var _ = this;

    $.ajax({
      type: 'POST',
      url: _.options.url,
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify(THOM_searchFilters),
      dataType: 'json',
      success: function (data) {
        _.refreshFilters(data);
      }
    })
  }

  /* Refresh Filters class */
  Thomsearch.prototype.refreshFilters = function (obj) {
    var _ = this;
    // _.pageNumber = 0;

    $(_.options.filterClass).removeClass('is-refreshing');

    for (var i = 0; i < obj.Filters.length; i++) {
      var id = obj.Filters[i].Id;
      var name = obj.Filters[i].Name;
      var filters = obj.Filters[i].Filters;

      for (var j = 0; j < filters.length; j++) { 
        
        
        var filter_Id = filters[j].Id;
        var filter_Name = filters[j].Name;
        var filter_isSelected = filters[j].Selected;
        var filter_isActive = filters[j].Active;


        if (filter_isSelected) {
          $(_.options.filterClass).each(function(){
            if($(this).data('val') === filter_Id) {
              $(this).addClass('is-selected');
            }
          });
        } else {
          $(_.options.filterClass).each(function(){
            if($(this).data('val') === filter_Id) {
              $(this).removeClass('is-selected');
            }
          });
        }

        if (filter_isActive) {
          $(_.options.filterClass).each(function(){
            if($(this).data('val') === filter_Id) {
              $(this).removeClass('is-inactive');
            }
          });
        } else {
          $(_.options.filterClass).each(function(){
            if($(this).data('val') === filter_Id) {
              $(this).addClass('is-inactive');
            }
          });
        }
      }
    }

    _.getFilteredContents();
  }

  /* Get Object - filter and change value */
  Thomsearch.prototype.getObjects = function (obj, key, val, keyToModify, newVal) {
    var _ = this

    var newValue = newVal
    var objects = []
    for (var i in obj) {
      if (!obj.hasOwnProperty(i)) continue
      if (typeof obj[i] === 'object') {
        objects = objects.concat(_.getObjects(obj[i], key, val, keyToModify, newValue))
      } else if (i == key && obj[key] == val) {
        obj[keyToModify] = newValue
      }
    }

    return obj
  }

  // ---------------------------
  // Thommenu - fn
  // ---------------------------
  $.fn.thomsearch = function () {
    var _ = this,
      opt = arguments[0],
      args = Array.prototype.slice.call(arguments, 1),
      l = _.length,
      i,
      ret
    for (i = 0; i < l; i++) {
      if (typeof opt === 'object' || typeof opt === 'undefined') { _[i].thomsearch = new Thomsearch(_[i], opt) } else { ret = _[i].thomsearch[opt].apply(_[i].thomsearch, args) }
      if (typeof ret !== 'undefined') return ret
    }
    return _
  }
}))
